var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('m-ripple',{attrs:{"color":"#fff"},on:{"click":function($event){return _vm.$emit('click')}}},[_c('div',{staticClass:"btn btn-primary"},[_vm._v(_vm._s(_vm.text))])])}
var staticRenderFns = []

export { render, staticRenderFns }